export default "627088d529c47b23.woff"